import { render, staticRenderFns } from "./PopUpCadastroPontoInteresse.vue?vue&type=template&id=26bc78d8&"
import script from "./PopUpCadastroPontoInteresse.vue?vue&type=script&lang=js&"
export * from "./PopUpCadastroPontoInteresse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports